import uuid from 'uuid/v4';

export default {
  /* Common functions to format data */
  strLang: (lang, en, it) => {
    let string = "";
    switch (lang) {
      case "en":
        string = en;
        break;
      case "it":
        string = it;
        break;
      default:
        string = en;
    }
    return string;
  },
  capitalizeFirst: string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  getObjIcon(obj, def) {
    if (obj && obj.image && obj.image !== "") {
      return obj.image;
    } else if (obj && obj.fbId && obj.fbId !== "" && obj.fbId != 0) {
      return "https://graph.facebook.com/" + obj.fbId + "/picture?type=large&access_token=746342188714963|68064b3b41c925ad8347e24b65233d0e";
    } else {
      return this.icons.getWorldIcon(def);
    }
  },
  getContactIcon(contact, store) {
    if (contact.user) {
      const user = store.getters["users/get"](contact.user);
      return this.getObjIcon(user, "userDefault");
    } else if (contact.work) {
      const work = store.getters["works/get"](contact.work);
      return this.getObjIcon(work, "workDefault");
    } else if (contact.type && contact.type == 2) {
      const work = store.getters["works/get"](contact.work);
      return this.getObjIcon(work, "workMaterial");
    } else {
      return this.getObjIcon(contact, "userDefault");
    }
  },
  getContactName(contact, store) {
      return `${contact.firstName || ""} ${contact.middleName || ""} ${contact.lastName || ""}`;
  },
  getContactReferrerName(contact, store) {
    if((contact.referrerFirstName || contact.referrerLastName)
        || (contact.referrerFirstName !== '' && contact.referrerLastName !== '')){
        return `- ${contact.referrerFirstName} ${contact.referrerLastName}`;
    } 
    // else {
    //   const companyContacts = store.getters["contacts/getAll"].filter(
    //     c =>
    //       c.workOwner == contact.workOwner &&
    //       c.firstName != '' && c.lastName != '' &&
    //       (
    //         (c.company && c.company.toUpperCase() == contact.firstName.toUpperCase())
    //         || (c.companyContact && c.companyContact == contact.idContactsContact)
    //       )
    //   );
    //   if (companyContacts && companyContacts.length > 0) {
    //     const cntc = companyContacts[0];
    //     return `- ${cntc.firstName} ${cntc.lastName}`;
    //   } 
    // }
    return "";
  },
  getReferrerFlag(contact, store) {
    let license = store.getters["licenses/getByWork"](!contact.workOwner ? 0 : contact.workOwner);
    return license 
           && license.config 
           && license.config.contacts 
           && license.config.contacts["use-referrer-contact"] == 0 ? 0 : 1;
  },
  /* Cookie management */
  getCookie(name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(name + "=");
      if (c_start != -1) {
        c_start = c_start + name.length + 1;
        let c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  },
  setCookie(name, val, exp, secure) {
    const d = new Date();
    d.setTime(d.getTime() + exp * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      name + "=" + val + ";" + expires + ";path=/;domain=" + process.env.VUE_APP_MAIN_DOMAIN + ";" + (!!secure ? "Secure;SameSite=None;" : "");
  },
  /* Offline management */
  genLocalId() {
    return uuid();
  },
  print(html, styles) {
    // Create iframe
    const iframe = window.document.createElement('iframe');
    iframe.setAttribute('src', 'about:blank');
    iframe.setAttribute('style', 'visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;');
    iframe.setAttribute('width', '0');
    iframe.setAttribute('height', '0');
    iframe.setAttribute('wmode', 'opaque');

    window.document.body.appendChild(iframe);

    const { contentWindow, contentDocument } = iframe;
    if (!contentDocument || !contentWindow) return;

    const doc = contentWindow.document;
    if (!doc) return;

    iframe.addEventListener('load', () => {
      const result = contentWindow.document.execCommand('print', false, null);
      if (!result) {
        contentWindow.print();
      }
    }, false);

    contentWindow.addEventListener('afterprint', () => {
      window.document.body.removeChild(iframe);
    })

    doc.open();
    doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>');

    // append styles to head
    styles.forEach(s => {
      doc.head.appendChild(s);
    });

    // Append the body
    doc.body.appendChild(html);

    // Close the document
    doc.close();
  },
  getImagePath(url) {
    if (typeof url === "string") {
      if(url.substr(0, 4) === 'http') {
        return url;
      } else {
        return process.env.VUE_APP_BACK_DOMAIN + process.env.VUE_APP_BACK_BASE_URL + url;
      }
    } else {
      return url.src;
    }
  },
  round(number, precision) {
    const factor = Math.pow(10, precision);
    const tempNumber = (number + Number.EPSILON) * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
  },
  getAddressFromPlace(_vm, place) {
    if(place.addressCity !== '') {
      return `${place.addressStreet} ${place.addressNumber}, ${place.addressZip} ${place.addressCity} ${place.addressState}, ${_vm.$anm22.tableClasses.worldCountry().getById(place.addressCountry)[_vm.lang]}`;
    } else {
      return '';
    }
  },
  nl2br(str) {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br/>' + '$2');
  },
  escapeHtml(text) {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
  },
  parseInputDate(val) {
    const tokens = val.replace('/', '-').split('-');
    return tokens.map(t => t.padStart(2, '0')).join('-');
  },
  parseInputTime(val) {
    const tokens = val.replace(/[.,;]/i, ':').split(':');
    return tokens.map(t => t.padStart(2, '0')).join(':');
  },
  loadScript(id, src, callback) {
    const head = document.getElementsByTagName("head")[0];
    if (document.getElementById(id)) {
      callback();
      return;
    }
    const js = document.createElement('script');
    js.id = id;
    js.src = src;
    // js.onreadystatechange = () => {
    //   if (js.readyState == "complete") callback();
    // };
    js.onload = callback;
    head.appendChild(js);
  },
  getFileExtension(fname) {
    return fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
  },
  copyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    //
    // *** This styling is an extra step which is likely not required. ***
    //
    // Why is it here? To ensure:
    // 1. the element is able to have focus and selection.
    // 2. if element was to flash render it has minimal visual impact.
    // 3. less flakyness with selection and copying which **might** occur if
    //    the textarea element is not visible.
    //
    // The likelihood is the element won't even render, not even a flash,
    // so some of these are just precautions. However in IE the element
    // is visible whilst the popup box asking the user for permission for
    // the web page to copy to the clipboard.
    //
  
    // Place in top-left corner of screen regardless of scroll position.
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
  
    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';
  
    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = 0;
  
    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
  
    // Avoid flash of white box if rendered for any reason.
    textArea.style.background = 'transparent';
  
  
    textArea.value = text;
  
    document.body.appendChild(textArea);
  
    textArea.select();
  
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('Oops, unable to copy');
    }
  
    document.body.removeChild(textArea);
  },
  /**
   *
   *  MD5 (Message-Digest Algorithm)
   *  http://www.webtoolkit.info/
   *
   **/
  MD5: function(string) {
    function RotateLeft(lValue, iShiftBits) {
      return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
    }

    function AddUnsigned(lX, lY) {
      var lX4, lY4, lX8, lY8, lResult;

      lX8 = lX & 0x80000000;

      lY8 = lY & 0x80000000;

      lX4 = lX & 0x40000000;

      lY4 = lY & 0x40000000;

      lResult = (lX & 0x3fffffff) + (lY & 0x3fffffff);

      if (lX4 & lY4) {
        return lResult ^ 0x80000000 ^ lX8 ^ lY8;
      }

      if (lX4 | lY4) {
        if (lResult & 0x40000000) {
          return lResult ^ 0xc0000000 ^ lX8 ^ lY8;
        } else {
          return lResult ^ 0x40000000 ^ lX8 ^ lY8;
        }
      } else {
        return lResult ^ lX8 ^ lY8;
      }
    }

    function F(x, y, z) {
      return (x & y) | (~x & z);
    }

    function G(x, y, z) {
      return (x & z) | (y & ~z);
    }

    function H(x, y, z) {
      return x ^ y ^ z;
    }

    function I(x, y, z) {
      return y ^ (x | ~z);
    }

    function FF(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));

      return AddUnsigned(RotateLeft(a, s), b);
    }

    function GG(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));

      return AddUnsigned(RotateLeft(a, s), b);
    }

    function HH(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));

      return AddUnsigned(RotateLeft(a, s), b);
    }

    function II(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));

      return AddUnsigned(RotateLeft(a, s), b);
    }

    function ConvertToWordArray(string) {
      var lWordCount;

      var lMessageLength = string.length;

      var lNumberOfWords_temp1 = lMessageLength + 8;

      var lNumberOfWords_temp2 =
        (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;

      var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;

      var lWordArray = Array(lNumberOfWords - 1);

      var lBytePosition = 0;

      var lByteCount = 0;

      while (lByteCount < lMessageLength) {
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;

        lBytePosition = (lByteCount % 4) * 8;

        lWordArray[lWordCount] =
          lWordArray[lWordCount] |
          (string.charCodeAt(lByteCount) << lBytePosition);

        lByteCount++;
      }

      lWordCount = (lByteCount - (lByteCount % 4)) / 4;

      lBytePosition = (lByteCount % 4) * 8;

      lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);

      lWordArray[lNumberOfWords - 2] = lMessageLength << 3;

      lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;

      return lWordArray;
    }

    function WordToHex(lValue) {
      var WordToHexValue = "",
        WordToHexValue_temp = "",
        lByte,
        lCount;

      for (lCount = 0; lCount <= 3; lCount++) {
        lByte = (lValue >>> (lCount * 8)) & 255;

        WordToHexValue_temp = "0" + lByte.toString(16);

        WordToHexValue =
          WordToHexValue +
          WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
      }

      return WordToHexValue;
    }

    function Utf8Encode(string) {
      string = string.replace(/\r\n/g, "\n");

      var utftext = "";

      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);

        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode((c >> 6) | 192);

          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);

          utftext += String.fromCharCode(((c >> 6) & 63) | 128);

          utftext += String.fromCharCode((c & 63) | 128);
        }
      }

      return utftext;
    }

    var x = Array();

    var k, AA, BB, CC, DD, a, b, c, d;

    var S11 = 7,
      S12 = 12,
      S13 = 17,
      S14 = 22;

    var S21 = 5,
      S22 = 9,
      S23 = 14,
      S24 = 20;

    var S31 = 4,
      S32 = 11,
      S33 = 16,
      S34 = 23;

    var S41 = 6,
      S42 = 10,
      S43 = 15,
      S44 = 21;

    string = Utf8Encode(string);

    x = ConvertToWordArray(string);

    a = 0x67452301;
    b = 0xefcdab89;
    c = 0x98badcfe;
    d = 0x10325476;

    for (k = 0; k < x.length; k += 16) {
      AA = a;
      BB = b;
      CC = c;
      DD = d;

      a = FF(a, b, c, d, x[k + 0], S11, 0xd76aa478);

      d = FF(d, a, b, c, x[k + 1], S12, 0xe8c7b756);

      c = FF(c, d, a, b, x[k + 2], S13, 0x242070db);

      b = FF(b, c, d, a, x[k + 3], S14, 0xc1bdceee);

      a = FF(a, b, c, d, x[k + 4], S11, 0xf57c0faf);

      d = FF(d, a, b, c, x[k + 5], S12, 0x4787c62a);

      c = FF(c, d, a, b, x[k + 6], S13, 0xa8304613);

      b = FF(b, c, d, a, x[k + 7], S14, 0xfd469501);

      a = FF(a, b, c, d, x[k + 8], S11, 0x698098d8);

      d = FF(d, a, b, c, x[k + 9], S12, 0x8b44f7af);

      c = FF(c, d, a, b, x[k + 10], S13, 0xffff5bb1);

      b = FF(b, c, d, a, x[k + 11], S14, 0x895cd7be);

      a = FF(a, b, c, d, x[k + 12], S11, 0x6b901122);

      d = FF(d, a, b, c, x[k + 13], S12, 0xfd987193);

      c = FF(c, d, a, b, x[k + 14], S13, 0xa679438e);

      b = FF(b, c, d, a, x[k + 15], S14, 0x49b40821);

      a = GG(a, b, c, d, x[k + 1], S21, 0xf61e2562);

      d = GG(d, a, b, c, x[k + 6], S22, 0xc040b340);

      c = GG(c, d, a, b, x[k + 11], S23, 0x265e5a51);

      b = GG(b, c, d, a, x[k + 0], S24, 0xe9b6c7aa);

      a = GG(a, b, c, d, x[k + 5], S21, 0xd62f105d);

      d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);

      c = GG(c, d, a, b, x[k + 15], S23, 0xd8a1e681);

      b = GG(b, c, d, a, x[k + 4], S24, 0xe7d3fbc8);

      a = GG(a, b, c, d, x[k + 9], S21, 0x21e1cde6);

      d = GG(d, a, b, c, x[k + 14], S22, 0xc33707d6);

      c = GG(c, d, a, b, x[k + 3], S23, 0xf4d50d87);

      b = GG(b, c, d, a, x[k + 8], S24, 0x455a14ed);

      a = GG(a, b, c, d, x[k + 13], S21, 0xa9e3e905);

      d = GG(d, a, b, c, x[k + 2], S22, 0xfcefa3f8);

      c = GG(c, d, a, b, x[k + 7], S23, 0x676f02d9);

      b = GG(b, c, d, a, x[k + 12], S24, 0x8d2a4c8a);

      a = HH(a, b, c, d, x[k + 5], S31, 0xfffa3942);

      d = HH(d, a, b, c, x[k + 8], S32, 0x8771f681);

      c = HH(c, d, a, b, x[k + 11], S33, 0x6d9d6122);

      b = HH(b, c, d, a, x[k + 14], S34, 0xfde5380c);

      a = HH(a, b, c, d, x[k + 1], S31, 0xa4beea44);

      d = HH(d, a, b, c, x[k + 4], S32, 0x4bdecfa9);

      c = HH(c, d, a, b, x[k + 7], S33, 0xf6bb4b60);

      b = HH(b, c, d, a, x[k + 10], S34, 0xbebfbc70);

      a = HH(a, b, c, d, x[k + 13], S31, 0x289b7ec6);

      d = HH(d, a, b, c, x[k + 0], S32, 0xeaa127fa);

      c = HH(c, d, a, b, x[k + 3], S33, 0xd4ef3085);

      b = HH(b, c, d, a, x[k + 6], S34, 0x4881d05);

      a = HH(a, b, c, d, x[k + 9], S31, 0xd9d4d039);

      d = HH(d, a, b, c, x[k + 12], S32, 0xe6db99e5);

      c = HH(c, d, a, b, x[k + 15], S33, 0x1fa27cf8);

      b = HH(b, c, d, a, x[k + 2], S34, 0xc4ac5665);

      a = II(a, b, c, d, x[k + 0], S41, 0xf4292244);

      d = II(d, a, b, c, x[k + 7], S42, 0x432aff97);

      c = II(c, d, a, b, x[k + 14], S43, 0xab9423a7);

      b = II(b, c, d, a, x[k + 5], S44, 0xfc93a039);

      a = II(a, b, c, d, x[k + 12], S41, 0x655b59c3);

      d = II(d, a, b, c, x[k + 3], S42, 0x8f0ccc92);

      c = II(c, d, a, b, x[k + 10], S43, 0xffeff47d);

      b = II(b, c, d, a, x[k + 1], S44, 0x85845dd1);

      a = II(a, b, c, d, x[k + 8], S41, 0x6fa87e4f);

      d = II(d, a, b, c, x[k + 15], S42, 0xfe2ce6e0);

      c = II(c, d, a, b, x[k + 6], S43, 0xa3014314);

      b = II(b, c, d, a, x[k + 13], S44, 0x4e0811a1);

      a = II(a, b, c, d, x[k + 4], S41, 0xf7537e82);

      d = II(d, a, b, c, x[k + 11], S42, 0xbd3af235);

      c = II(c, d, a, b, x[k + 2], S43, 0x2ad7d2bb);

      b = II(b, c, d, a, x[k + 9], S44, 0xeb86d391);

      a = AddUnsigned(a, AA);

      b = AddUnsigned(b, BB);

      c = AddUnsigned(c, CC);

      d = AddUnsigned(d, DD);
    }

    var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);

    return temp.toLowerCase();
  }
};
